export const environment = {
  baseUrl: 'https://backendlms.ccscleaning.com/api/',
  socketUrl: 'https://backendlms.ccscleaning.com',
  backendSecretKey: 'KUNU-VolkovIndia-7777',
  localStorageSecretKey: 'beautiful129*876 Rashmi',
  production: true,
  adminUrl: '/admin',
  learnerUrl: '/learner',
  acccountManagerUrl: '/account-manager',
  areaManagerUrl: '/area-manager',
  serviceEngineerUrl: '/service-engineer',
  appUrl: 'https://academy.ccscleaning.com',
  ecosystemUrls: {
    connect: 'https://connect.ccscleaning.com',
    hub: 'https://core.ccscleaning.com',
    projects: 'https://projects.ccscleaning.com',
  },
  clientId: 'db729a6c-9768-46f7-9f27-08504eabc88d',
  allowed_countries: ['UK', 'IE', 'AT', 'BE', 'FR', 'DE', 'NL', 'PL'],
  authority: 'https://login.microsoftonline.com/4d2f2674-4fb2-4849-87f4-a7f7140172cc',
  guestUrl: '/guest',
  googlePlaceApiKey: 'AIzaSyAUc5KPygalKXNqkFmLtyL0ZurvXTl4mGM',
  aws: {
    region: 'eu-west-1',
    bucketName: 'amie2.0',
    folders: {
      courseQuestions: 'prod/course-questions/',
      courseThumbnails: 'prod/course-thumbnails/',
      courseLayouts: 'prod/course-layouts/',
      pageImages: 'prod/page-images/',
      pathlogos: 'prod/pathlogos/',
      badges: 'prod/badges/',
      products: 'prod/products/',
    },
  },
};
